import React from 'react';
import Dropdown, { DropdownProps } from '../Basics/Dropdown';
import { css } from '@emotion/react';
import tw from 'twin.macro';
import { ReactComponent as ArrowDown } from '$/images/arrowDown.svg';
import { FontSize } from '$/GraphQL/schema/schema';
import { FontSizeValue } from '$/shared/frontend/utils/fontSizes';
import { FontSizeIcon } from '$/images/FontAwesomeIcons';

const FontSizeItem: React.FC<{
  className?: string;
  fontFamily?: string;
  fontSize: FontSize;
}> = ({ fontSize, className, fontFamily }) => {
  return (
    <div
      className={className}
      css={[
        tw`flex justify-start items-baseline whitespace-no-wrap rounded-input`,
        css`
          min-width: 6rem;
        `,
      ]}
    >
      <span
        className='text-md text-color-input-field'
        css={css`
          font-family: ${fontFamily ?? 'inherit'};
          font-size: ${FontSizeValue[fontSize]}rem !important;
        `}
      >
        {fontSize}
      </span>
    </div>
  );
};

interface FontSizeProps extends DropdownProps {
  iconSize?: string;
  showSize?: boolean;
  value?: string;
}

const ThemeFontSizePicker: React.FC<FontSizeProps> = ({
  value,
  iconSize = '20px',
  showSize,
  placeholder,
  ...props
}) => {
  const options = React.useMemo(() => {
    return [
      {
        key: 1,
        text: FontSize.Small,
        value: FontSize.Small,
        icon: value === FontSize.Small ? 'check' : <span className='block w-2_5e' />,
        content: <FontSizeItem fontSize={FontSize.Small} />,
      },
      {
        key: 2,
        text: FontSize.Medium,
        value: FontSize.Medium,
        icon: value === FontSize.Medium ? 'check' : <span className='block w-2_5e' />,
        content: <FontSizeItem fontSize={FontSize.Medium} />,
      },
      {
        key: 3,
        text: FontSize.Large,
        value: FontSize.Large,
        icon: value === FontSize.Large ? 'check' : <span className='block w-2_5e' />,
        content: <FontSizeItem fontSize={FontSize.Large} />,
      },
      {
        key: 4,
        text: FontSize.XLarge,
        value: FontSize.XLarge,
        icon: value === FontSize.XLarge ? 'check' : <span className='block w-2_5e' />,
        content: <FontSizeItem fontSize={FontSize.XLarge} />,
      },
    ];
  }, [value]);

  return (
    <Dropdown
      {...props}
      basic
      fluid
      icon={null}
      trigger={
        <div className='flex items-center'>
          {/* <span
            css={css`
              font-size: ${iconSize};
              padding-bottom: 2px;
            `}
            className='text-color-input-field font-semibold mr-1/2e'
          >
            Aa
          </span>{' '} */}
          <FontSizeIcon
            css={css`
              font-size: ${iconSize};
              padding-bottom: 2px;
            `}
            className='text-color-input-field mr-1/2e h-1e'
          />
          <span className='text-color-input-field'>{showSize ? value ?? placeholder : null}</span>
          <ArrowDown
            className={`self-center transition-transform duration-100 text-color-arrowDown ${
              false ? 'rotate-180' : 'rotate-0'
            }`}
            css={css`
              ${showSize ? `margin-left: 0.75rem;` : ''}
            `}
          />
        </div>
      }
      options={options}
    />
  );
};

export default ThemeFontSizePicker;
